import React from 'react';
import { Button, Form } from 'antd';

import Input from 'components/components/Input';
import { AddIcon, TrashCanIcon } from 'assets/icons';
import { StartupNamesListProps } from 'types/ventureBuilders';
import { contactEmailRules, startupNameRules } from '../../utils';

import './StartupNamesList.scss';

const StartupNamesList = ({ name }: StartupNamesListProps) => (
  <Form.List
    name={name}
    rules={[
      {
        validator: async (_, startups?: unknown[]) => {
          if (!startups?.length) {
            throw new Error('Add at least one startup');
          }
        },
      },
    ]}
  >
    {(fields, { add, remove }, { errors }) => (
      <div className="startup-names-list">
        {fields.map((field, index) => (
          <div className="startup-names-list__row" key={field.key}>
            <Input
              name={[field.name, 'name']}
              label={`Startup ${index + 1} name`}
              rules={startupNameRules}
              className="startup-names-list__item"
            >
              <Input.InputField placeholder={`Startup ${index + 1} name`} autoComplete="off" />
            </Input>
            <Input
              name={[field.name, 'email']}
              label={`Startup ${index + 1} contact email`}
              rules={contactEmailRules}
              className="startup-names-list__item"
            >
              <Input.InputField placeholder={`Startup ${index + 1} contact email`} autoComplete="off" />
            </Input>
            <Button
              aria-label={`Remove startup ${index + 1}`}
              className="secondary-button startup-names-list__remove"
              icon={<TrashCanIcon />}
              disabled={fields.length === 1}
              onClick={() => remove(field.name)}
            />
          </div>
        ))}
        <Form.ErrorList errors={errors} />
        <Button className="secondary-button startup-names-list__add" icon={<AddIcon />} onClick={() => add({ name: '', email: '' })}>
          Add startup
        </Button>
      </div>
    )}
  </Form.List>
);

export default StartupNamesList;
